<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<div id="modal-idle">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'idle.title' | translate }}</h4>
    </div>
    <div class="modal-body">
        <p>{{ 'idle.click-to-continue' | translate }}</p>

        <p>{{ 'idle.deconnection' | translate }} <span
                *ngIf="timeLeft.hoursLeft > 0">{{timeLeft.hoursLeft}} {{ 'idle.hours' | translate }}, </span><span
                *ngIf="(timeLeft.minutesLeft > 0) && (timeLeft.hoursLeft < 1)">{{timeLeft.minutesLeft}} {{ 'idle.minutes' | translate }}
            , </span>{{timeLeft.secondsLeft}}
            {{ 'idle.seconds' | translate }}</p>
    </div>
    <div class="modal-footer">
        <button class="certificateClose" (click)="ping()">{{ 'idle.continue' | translate }}</button>
    </div>
</div>
